const IntegrationNames = {
  HUBSPOT: "hubspot",
  SALESFORCE: "salesforce"
} as const;

export default IntegrationNames;
